import { createContext, useContext, useRef, useCallback, useMemo } from "react"

const RefsContext = createContext(null)

export function RefsProvider({ children }) {
  const refs = useRef({})

  const getRef = useCallback((name) => {
    if (!refs.current[name]) {
      refs.current[name] = { current: null }
    }
    return refs.current[name]
  }, [])

  const value = useMemo(() => ({ getRef }), [getRef])

  return (
    <RefsContext.Provider value={value}>
      {children}
    </RefsContext.Provider>
  )
}

export function useSceneRef(name) {
  const ctx = useContext(RefsContext)
  if (!ctx) {
    throw new Error("useSceneRef must be used inside <RefsProvider>")
  }
  return ctx.getRef(name)
}
